import type { ReactNode } from 'react';

import { Box, type BoxProps } from '../Box/Box';

type AlignY = 'top' | 'center' | 'bottom';
type Align = 'left' | 'center' | 'right' | 'spaceBetween';

interface InlineProps extends Pick<BoxProps, 'gap' | 'className'> {
  align?: Align;
  alignY?: AlignY;
  nowrap?: boolean;
  children: ReactNode;
}

const resolveAlign: { [key in Align]: BoxProps['justifyContent'] } = {
  left: 'flexStart',
  center: 'center',
  right: 'flexEnd',
  spaceBetween: 'spaceBetween',
};

const resolveAlignY: { [key in AlignY]: BoxProps['alignItems'] } = {
  top: 'flexStart',
  center: 'center',
  bottom: 'flexEnd',
};

/**
 * @deprecated Use Mantine's Group component for horizontal layouts or Flex for custom layouts.
 * Import: import { Group, Flex } from '@mantine/core'
 */
export const Inline: React.FC<React.PropsWithChildren<InlineProps>> = ({
  children,
  align = 'left',
  alignY,
  gap,
  nowrap,
  className,
}) => {
  return (
    <Box
      display="flex"
      flexDirection="row"
      gap={gap}
      flexWrap={nowrap ? 'nowrap' : 'wrap'}
      justifyContent={resolveAlign[align]}
      alignItems={alignY ? resolveAlignY[alignY] : undefined}
      className={className}
    >
      {children}
    </Box>
  );
};
